function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "74",
  height: "38",
  viewBox: "0 0 74 38",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "racecar-path-1",
  d: "M0 .672h7.755v2.922H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "racecar-path-3",
  d: "M.404.787h70.13v36.65H.403z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.562 6.08h4.941c.777 0 1.406-.65 1.406-1.458 0-.807-.629-1.46-1.406-1.46h-4.94c-.778 0-1.407.653-1.407 1.46 0 .807.63 1.458 1.406 1.458",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 19.276)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "racecar-mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#racecar-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.349.672H1.406C.63.672 0 1.326 0 2.133s.631 1.46 1.406 1.46h4.943c.777 0 1.406-.653 1.406-1.46 0-.807-.63-1.46-1.406-1.46",
  fill: "currentColor",
  mask: "url(#racecar-mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.467 -.224)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "racecar-mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#racecar-path-3"
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.721 19.342L9.264 16.19V6.34l4.768 3.984.989.887 1.677-1.046 2.075-1.33c3.515-2.252 7.32-5.12 11.078-5.127h3.54c.616 0 1.218.12 1.79.361l15.266 9.579.373.236.424.105 16.477 3.567v1.786zm-3.192 5.255l-.858.19c-.538-1.079-1.534-2.583-3.115-3.372l7.165-.072c0 1.75-1.832 3.003-3.192 3.254zm-8.157 9.787c-3.004 0-5.451-2.54-5.451-5.664 0-3.12 2.447-5.66 5.451-5.66 3.005 0 5.45 2.54 5.45 5.66 0 3.124-2.445 5.664-5.45 5.664zm-8.108-7.247H28.04c-.631-3.216-3.004-5.774-6.043-6.583a.353.353 0 01-.26-.341c0-.203.166-.364.358-.354l29.618 1.484v.302a8.608 8.608 0 00-3.449 5.492zm-28.317 7.382c-3.007 0-5.451-2.54-5.451-5.663s2.444-5.665 5.45-5.665c3.005 0 5.45 2.542 5.45 5.665 0 3.124-2.445 5.663-5.45 5.663zm-7.033-10.114l-3.45-1.673-.188-.092-.012-.003v-3.526l9.334.492c.18.008.323.164.323.351v.12a.35.35 0 01-.289.349c-2.422.405-4.484 1.886-5.718 3.982zM69.4 15.508L51.903 11.15l-15.44-9.691A7.414 7.414 0 0033.39.787h-3.62c-4.416.01-8.716 3.154-12.472 5.563l-2.075 1.327-5.619-4.4H7.641c-.656 0-1.19.554-1.19 1.238v7.17c-.041-.005-.078-.028-.125-.028l-4.516-.003c-.777 0-1.406.651-1.406 1.458 0 .807.626 1.46 1.403 1.46l4.517.006h.002c.044 0 .084-.023.126-.028v8.29c0 1.173.742 2.208 1.823 2.539l3.581 1.735a8.817 8.817 0 00-.175 1.742c0 4.733 3.71 8.582 8.266 8.582 4.159 0 7.575-3.218 8.145-7.377h20.15c.62 4.092 4.016 7.244 8.13 7.244 4.556 0 8.264-3.85 8.264-8.585 0-.387-.062-.76-.111-1.132l.594-.133c3.133-.572 5.414-3.396 5.414-6.699v-3.713c0-.723-.466-1.35-1.134-1.535z",
  fill: "currentColor",
  mask: "url(#racecar-mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.915 6.979a1.345 1.345 0 00-.71-.2h-4.48c-.513 0-.982.282-1.236.74l-3.574 6.443 19.748.597c.73.025 1.009-.977.38-1.359L36.915 6.98z",
  fill: "currentColor"
}))));